// actionTypes.js
export const SET_VALUE_Impression = "SET_VALUE_Impression";
export const SET_DATE_Impression = "SET_DATE_Impression";
export const SET_CURRENT_PAGE_Impression = "SET_CURRENT_PAGE_Impression";
export const SET_ORDER_Impression = "SET_ORDER_Impression";
export const SET_SORT_FIELD_Impression = "SET_SORT_FIELD_Impression";
export const SET_VALID_Impression = "SET_VALID_Impression";
export const SET_CATEGORIE_Impression = "SET_CATEGORIE_Impression";
